<template>
  <div>
    <!-- 头部返回组件 -->
    <navBar title="登录"></navBar>
    <div class="login_wrap">
      <van-cell-group>
        <van-field v-model="phone" required label="手机号:" clearable type="number" maxlength="11" placeholder="请输入手机号" :error-message="phoneError" @click="phoneInput" />
        <van-field v-model="sms" v-if="loginTypeBtn" required center clearable label="短信验证码:" maxlength="6" placeholder="请输入短信验证码" :error-message="smsError" @click="smsInput">
          <van-button slot="button" v-if="shot" size="small" type="primary" @click="smsOutFn()">发送验证码</van-button>
          <van-button slot="button" v-else size="small" type="primary">{{times}}</van-button>
        </van-field>
        <van-field v-model="password" v-else required label="密码:" type="password" placeholder="请输入密码" :error-message="passwordError" />
        <!-- <van-button size="small" type="primary" @click="loginTypeCutFn()">{{loginTypeCut}}</van-button> -->
      </van-cell-group>
      <div class="login" @click="loginFn()">
        <p>手机绑定</p>
      </div>
    </div>

  </div>
</template>

<script>
  import navBar from "../components/navBar";
  import { Toast, Field, CellGroup, Button } from 'vant';
  import {getUrlKey, getIntoUrl} from '../assets/js/commonFn.js';

  export default {
    name: 'webLogin',
    data() {
      return {
        phone: '',   // 手机号
        sms: '',   // 短信验证码
        password: '',  // 密码
        phoneError: '',  // 手机号报错
        smsError: '',    // 验证码报错
        passwordError: '',  // 密码报错
        loginTypeCut: '密码登录',   // 登录方式切换，默认短信登录
        loginTypeBtn: true,  // 默认显示短信登录
        shot: true, // 发送验证码
        times: null,  // 倒计时时长
        loginTypeService: null,  // 登录类型选择提交给后台
        openID: '',  // 微信openid
        weixinUrl: '',   // 公众号打开记录的进入时的原始路由
        accountSn: '',   // 记录每个用户的身份信息，已区别用户拉新
        shakeBtn: true,  // 防抖
      }
    },
    created() {

    },
    mounted(){

    },
    components:{
      navBar,
      [Toast.name]: Toast,
      [Field.name]: Field,
      [CellGroup.name]: CellGroup,
      [Button.name]: Button,
    },
    methods: {

      // 登录方式切换
      loginTypeCutFn(){
        if(this.loginTypeCut === '密码登录'){
          this.loginTypeCut = '验证码登录';
          this.loginTypeBtn = false;
          return;
        }

        if(this.loginTypeCut === '验证码登录'){
          this.loginTypeCut = '密码登录';
          this.loginTypeBtn = true;
          return;
        }
      },

      // 手机号输入的时候
      phoneInput(){
        this.phoneError = '';
      },

      // 验证码输入的时候
      smsInput(){
        this.smsError = '';
      },

      // 点击发送短信验证码
      smsOutFn(){
        if(!this.phone){
          this.phoneError = '请输入手机号';
          return
        }
        else if(!(/^1[3456789]\d{9}$/.test(this.phone))){
          this.phoneError = '手机号错误';
          return
        }
        else{
          this.phoneError = '';
        }

        this.sms = '';
        this.password = '';

        let item2 = 60;

        // 开一个定时器
        let time1 = setInterval( () => {
          item2 --;
          if(item2 == 0){
            this.shot = true;
            clearInterval(time1)
          }
          else{
            this.times = item2 + 's'
            this.shot = false;
          }
        }, 1000);

        this.sendHttp({
          method: 'post',
          url: `${this.accountUrl}/partnerlogin/sms`,
          data: {
            mobile: this.phone,
          }
        }).then( res => {
          if(res.code == '0'){
            Toast({
              message: `${res.msg}`,
              duration: 1500,
            })
          }
          else{
            Toast({
              message: `${res.msg}`,
              duration: 1500,
            })
          }
        })

      },

      // 点击登录
      loginFn(){
        if(!this.phone){
          this.phoneError = '请输入手机号';
          return
        }
        else if(!(/^1[3456789]\d{9}$/.test(this.phone))){
          this.phoneError = '手机号错误';
          return
        }
        else{
          this.phoneError = '';
        }

        if(this.loginTypeBtn){
          if(!this.sms){
            this.smsError = '验证码不能空';
            return;
          }
          else{
            this.smsError = '';
          }
          this.loginTypeService = 'sms';
        }
        else{
          if(!this.password){
            this.passwordError = '密码不能空';
            return;
          }
          else{
            this.passwordError = '';
          }
          this.loginTypeService = 'password';
        }

        this.openID = window.localStorage.getItem("setWapWeixinOpenid");
        let jsUrl = window.localStorage.getItem("fromPath");

        this.weixinUrl = getIntoUrl(jsUrl);

        let cat_id = getUrlKey("cat_id", jsUrl);
        let id = getUrlKey("id", jsUrl);
        let kyw = getUrlKey("kyw", jsUrl);
        let relation = getUrlKey("relation", jsUrl);
        let account_sn = getUrlKey("account_sn", jsUrl);

        if(account_sn){
          this.accountSn = account_sn;
        }
        else{
          this.accountSn = '';
        }

        if(this.shakeBtn){
          this.shakeBtn = false;
          this.sendHttp({
            method: 'post',
            url: `${this.accountUrl}/partnerlogin/login`,
            data: {
              mobile: this.phone,
              sms_code: this.sms,
              type: this.loginTypeService,
              password: this.password,
              openid: this.openID,
              account_sn: this.accountSn,
            }
          }).then( res => {
            console.log(res)
            if(res.code == 0){
              // 保存用户身份
              window.localStorage.setItem('partner_type', res.data.partner_type);

              this.$router.push({
                path: this.weixinUrl,
                query: {
                  cat_id,
                  id,
                  kyw,
                  relation,
                }
              });

              this.shakeBtn = true;
            }
            else{
              Toast({
                message: `${res.msg}`,
                duration: 1500,
              });
              this.$router.push('/');
            }
          })
        }
      },

    },

  }
</script>

<style scoped lang="less">
  .login_wrap{
    margin: 50px 0 20px;
    width: 100%;
    padding: 0 8px 2px;
    box-sizing: border-box;
    background: #fff;
  }
  .login{
    width: 100px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    font-size: 14px;
    color: #fff;
    background: #687BFF;
    border-radius: 4px;
    margin: 10px auto;
  }
</style>
